import React, { Fragment } from 'react'
import Trigger3DBaseSphere from './Trigger3DBase.sphere'
import Trigger3DBaseCircle from './Trigger3DBase.circle'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import getBool from 'aria-viewer/utils/getBool'
import { getEnv } from 'aria-viewer/utils/environment'

const enableGaze = getBool(getEnv('REACT_APP_ENABLE_GAZE_LISTENER'))

import { Trigger3DSizes } from 'aria-viewer/interactive-element/components/3d/trigger3D/constants/'

const Trigger3D = ({
    radius,
    baseTexture,
    reflectionTexture,
    video,
    onClick,
    onHover,
    onHoverExit,
    type,
    isMobile,
    ...props
}) => (
    <Fragment>
        {
            {
                sphere: (
                    <Fragment>
                        <Trigger3DBaseSphere
                            textureResource={baseTexture}
                            radius={radius * 2}
                            video={video}
                            mouseOutCallback={onHoverExit}
                            mouseOverCallback={onHover}
                            onClick={onClick}
                            key={'baseSphere'}
                            {...props}
                        />
                        <Trigger3DBaseSphere
                            textureResource={reflectionTexture}
                            radius={radius + 0.005}
                            reflection={true}
                            key={'reflectionSphere'}
                            enableGaze={true}
                            {...props}
                        />
                    </Fragment>
                ),
                circle: (
                    <Trigger3DBaseCircle
                        textureResource={baseTexture}
                        radius={radius * 2}
                        video={video}
                        mouseOutCallback={onHoverExit}
                        mouseOverCallback={onHover}
                        onClick={onClick}
                        isMobile={isMobile}
                        enableGaze={true && enableGaze}
                        {...props}
                    />
                ),
            }[type]
        }
    </Fragment>
)

Trigger3D.defaultProps = {
    radius: Trigger3DSizes.TRIGGER_RADIUS,
    scale: Trigger3DSizes.TRIGGER_DEFAULT_SCALE,
    checkScale: Trigger3DSizes.VISITED_CHECK_SCALE,
    checkOffset: Trigger3DSizes.VISITED_CHECK_OFFSET,
    type: 'circle',
    baseTexture: '',
    reflectionTexture: '',
    video: '',
    onClick: () => {},
    onHover: () => {},
    onHoverExit: () => {},
}
export default compose(pure)(Trigger3D)
